// ===== KIANE PRODUCTS DATA =====
// All prices in Indian Rupees (₹)

export const PRODUCTS = [
  {
    id: 'classic',
    name: 'Classic',
    subtitle: 'Instant Breakfast Mix',
    description:
      'Wholesome rolled oats, cereals blend and a premium nut & seed topping. Milky, delicious and ready in minutes — just add hot water.',
    image: '/Classic.webp',
    images: ['/Classic/Front.webp', '/Classic/Back.webp', '/Classic/Info.webp'],
    mrp: 89,
    price: 79,
    badge: 'Fan Favourite',
    highlights: ['High in Fibre', 'Source of Protein', 'No Refined Sugar', 'Vegetarian'],
    weight: 65, // weight in grams
  },
  {
    id: 'choco',
    name: 'Choco Delight',
    subtitle: 'Instant Breakfast Mix',
    description:
      'All the wholesome goodness of Classic with a rich chocolate twist. A warm, indulgent bowl that still keeps things clean and nourishing.',
    image: '/Choco-Delight.webp',
    images: ['/Choco/Front.webp', '/Choco/Back.webp', '/Choco/Info.webp'],
    mrp: 99,
    price: 89,
    badge: 'New Flavour',
    highlights: ['Rich Chocolate Taste', 'Source of Protein', 'No Refined Sugar', 'Vegetarian'],
    weight: 65, // weight in grams
  },
 
  {
    id: 'goond_badam_crumble',
    name: 'Goond Badam Crumble',
    subtitle: 'Traditional Indian Snack',
    description:
      'Made in small batches and roasted in pure desi ghee, our Goond Badam Crumble brings together the goodness of edible gum (gond), premium almonds, magaj and crunchy makhana. A delicious, nutty and wholesome traditional Indian snack, made without artificial additives.',
    image: '/Goond_Badam_Crumble/Info.webp',
    images: [
      '/Goond_Badam_Crumble/Info.webp'
    ],
    mrp: 189,
    price: 179,
    badge: 'Traditional Favourite',
    highlights: [
      'Roasted in Desi Ghee',
      'Made with Gond & Almonds',
      'Loaded with Nuts & Makhana',
      'Small-Batch Homemade',
      'No Artificial Additives'
    ],
    weight: 85, // weight in grams
  },

];

// ===== PACK COMBINATIONS =====
// Pack of 4
export const PACKS_OF_4 = [
  {
    id: 'pack-4-classic',
    name: 'Classic × 4',
    type: 'same',
    size: 4,
    contents: [{ productId: 'classic', qty: 4 }],
    originalPrice: 356, // MRP
    price: 299,
    saving: 57,
    badge: '16% off',
    description: 'Four packs of the fan-favourite Classic mix.',
  },
  {
    id: 'pack-4-choco',
    name: 'Choco Delight × 4',
    type: 'same',
    size: 4,
    contents: [{ productId: 'choco', qty: 4 }],
    originalPrice: 396, // MRP
    price: 339,
    saving: 57,
    badge: '14% off',
    description: 'Four packs of the indulgent Choco Delight mix.',
  },
  {
    id: 'pack-4-mix',
    name: 'Mix Pack of 4',
    type: 'mix',
    size: 4,
    contents: [
      { productId: 'classic', qty: 2 },
      { productId: 'choco', qty: 2 },
    ],
    originalPrice: 376, // MRP
    price: 319,
    saving: 57,
    badge: '15% off',
    description: '2 Classic + 2 Choco Delight — try both flavours.',
  },
];

// Pack of 8
export const PACKS_OF_8 = [
  {
    id: 'pack-8-classic',
    name: 'Classic × 8',
    type: 'same',
    size: 8,
    contents: [{ productId: 'classic', qty: 8 }],
    originalPrice: 712, // MRP
    price: 549,
    saving: 163,
    badge: '23% off',
    description: 'Eight packs of Classic — your whole week sorted.',
  },
  {
    id: 'pack-8-choco',
    name: 'Choco Delight × 8',
    type: 'same',
    size: 8,
    contents: [{ productId: 'choco', qty: 8 }],
    originalPrice: 792, // MRP
    price: 629,
    saving: 163,
    badge: '21% off',
    description: 'Eight packs of Choco Delight for a rich week ahead.',
  },
  {
    id: 'pack-8-mix',
    name: 'Mix Pack of 8',
    type: 'mix',
    size: 8,
    contents: [
      { productId: 'classic', qty: 4 },
      { productId: 'choco', qty: 4 },
    ],
    originalPrice: 752, // MRP
    price: 619,
    saving: 133,
    badge: '18% off',
    description: '4 Classic + 4 Choco Delight — maximum variety, maximum savings.',
  },
];

export const ALL_PACKS = [...PACKS_OF_4, ...PACKS_OF_8];
